module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJmbGFnLWljb24tY3NzLXNlIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iIzA2NmFhNyIgZD0iTTAgMGg2NDB2NDgwSDB6Ii8+CiAgPHBhdGggZmlsbD0iI2ZlY2MwMCIgZD0iTTAgMTkyaDY0MHY5NkgweiIvPgogIDxwYXRoIGZpbGw9IiNmZWNjMDAiIGQ9Ik0xNzYgMGg5NnY0ODBoLTk2eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sv.svg
// module id = 1405
// module chunks = 1